<mat-tab-group animationDuration="0ms" [disableRipple]="true" (selectedTabChange)="tabChange($event)" [(selectedIndex)]="selectedIndex">
    <mat-tab *ngFor="let t of tabsArr" [label]="t.name" [disabled]='t.disable'></mat-tab>
</mat-tab-group>